import React from 'react'
import { Box, Grid } from '@mui/material';
import TestCaseSetRequest from './TestCaseSetRequest';
import TestCaseSetEntityResponse from './TestCaseSetEntityResponse';
import TestRules from './TestRules';

const TestCaseSetBody = (props) => {
  return (
    <Box>
      <Grid container sx={{ height: '100%' }}>
        <Grid item md={7} xs={12} sx={{ height: '100%' }}>
          <Box sx={{ height: '100%' }}>
            <TestCaseSetRequest {...props} key={props.testCase?.id + props.testCase.entity?.id} />
          </Box>
        </Grid>
        <Grid item md={5} xs={12} sx={{ height: '100%' }}>
          <Box sx={{ height: '100%' }}>
            <TestCaseSetEntityResponse testCase={props.testCase} isExpanded={props.isExpanded} selectedEnvironmentId={props.selectedEnvironmentId} />
          </Box>
        </Grid>
        <Grid item md={12} xs={12} sx={{ my: 2 }}>
          <TestRules testCase={props.testCase} isExpanded={props.isExpanded} />
        </Grid>
      </Grid>
    </Box >
  )
}

export default TestCaseSetBody;
